export const ImageExtensions = ".jpg,.jpeg,.png";
export const PDFExtensions = ".pdf";
export const AllExtensions = "*"
export const Android = "android";
export const IOS = "ios";

export const NewsDirectory = "news";
export const GSTDocsDirectory = "gstdocs";
export const HelpdeskDirectory = "helpdesk";
export const ProfilePhotoDirectory = "profilephoto";
export const OffersDirectory = "offers";
export const MembershipDirectory = "membership";
export const ItemPhotoDirectory = "iiab2b";

export const MagazineDirectory = "magazine";
